import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  UserGroupMembersRequest,
  UserGroupRecord,
} from "../UserGroupRecord";

import * as UseUserGroups from "./useUserGroups";

interface AddUserGroupMembersArgs {
  userGroupId: string;
  request: UserGroupMembersRequest;
}

export function useAddUserGroupMembers() {
  const { userGroupService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<UserGroupRecord, Error, AddUserGroupMembersArgs>({
    mutationFn: ({ userGroupId, request }) =>
      userGroupService.addMembers(userGroupId, request),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseUserGroups.getQueryKey(),
      });
    },
  });
}
